import { onVisibilityChange } from "helpers/visibilityHelper";
import logger from "logging/logger";
import React from "react";
import { selectIsMobile } from "modules/deviceInfo";
import { useSelector } from "react-redux";

const MobileHandler = () => {
  const isMobileView = useSelector(selectIsMobile);

  React.useEffect(() => {
    if (isMobileView) {
      onVisibilityChange((visible?: boolean) => {
        if (isMobileView && !visible) {
          try {
            // Do not proceed with any loading if tab is put in background
            window.stop();
          } catch (error) {
            logger.error(`[MobileHandler] error: ${JSON.stringify(error)}`);
          }
        }
      });
    }
  }, [isMobileView]);

  return null;
};

export default MobileHandler;
